import Drawer from '@mui/material/Drawer';
import clsx from 'clsx';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { CustomTypography } from '../custom/CustomTypography';
import { ActionButtons } from '../shared/ActionButtons';
import styles from './SidePanel.module.css';
import { SidePanelHeader } from './SidePanelHeader';
import { SvgIconProps } from '@mui/material/SvgIcon';

interface ISidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  isNoBackdrop?: boolean;
  handleConfirm?: () => void;
  buttonConfirmTitle?: string;
  disabledButtonConfirm?: boolean;
  AdditionalAction?: () => void;
  customAdditionalText?: string;
  CustomAdditionalIcon?: React.ElementType<SvgIconProps>;
  children: React.ReactNode;
}
export const SidePanel: FC<ISidePanelProps> = ({
  children,
  onClose,
  isOpen,
  title,
  description,
  isNoBackdrop,
  handleConfirm,
  buttonConfirmTitle,
  disabledButtonConfirm,
  AdditionalAction,
  customAdditionalText,
  CustomAdditionalIcon,
}) => {
  const isMobile = useSelector((state: RootState) => state.app.isMobile);

  return (
    <Drawer
      classes={{ paper: styles.drawerPaper }}
      slotProps={{
        backdrop: { className: isNoBackdrop ? styles.backdrop : '' },
      }}
      onClose={onClose}
      open={isOpen}
      anchor={isMobile ? 'bottom' : 'right'}
      variant="temporary"
    >
      <SidePanelHeader
        title={title}
        action={AdditionalAction}
        actionText={customAdditionalText}
        ActionIcon={CustomAdditionalIcon}
        onClose={onClose}
      />
      {description && (
        <div className={styles.description}>
          <CustomTypography className={clsx('text-15')} color="grey">
            {description}
          </CustomTypography>
        </div>
      )}
      {children}
      {handleConfirm && (
        <ActionButtons
          handleCancel={onClose}
          confirmTitle={buttonConfirmTitle || 'Сохранить'}
          handleConfirm={handleConfirm}
          disabled={disabledButtonConfirm}
        />
      )}
    </Drawer>
  );
};
